import gsap from 'gsap'

export const animateCheckmarkBounceIn = (
  target: HTMLElement | null
): gsap.core.Tween | undefined => {
  if (!target) return undefined

  return gsap.fromTo(
    target,
    { scale: 0, opacity: 0 },
    {
      scale: 1,
      opacity: 1,
      duration: 0.7,
      ease: 'elastic.out(1, 0.6)',
      transformOrigin: 'center',
    }
  )
}
